import { useRouter } from 'next/router';
import * as React from 'react';
import { FullScreenLoader } from 'common/components/FullScreenLoader';
import { RestaurantMain } from 'restaurant/components/RestaurantMain';

export const Reservation = () => {
    const router = useRouter();

    const { restaurantId } = router.query;

    if (typeof restaurantId !== 'string') return <FullScreenLoader componentOrShow={false} />;

    return (
        <RestaurantMain page="create" restaurantId={restaurantId} />
    );
};

export default Reservation;
